import { X } from "../../../../assets/media/icons";
import facebook from "../../../../assets/media/icons/facebook";
import instagram from "../../../../assets/media/icons/instagram";
import linkedin from "../../../../assets/media/icons/linkedin";
import youtube from "../../../../assets/media/icons/youtube";

interface AppStoreLinks {
  ios: string;
  android: string;
}

interface AppFeature {
  emoji: string;
  label: string;
  ariaLabel: string;
}

export const legalLinks = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/cookie-policy", label: "Cookie Policy" },
  { to: "/terms", label: "Terms" },
];

export const APP_FEATURES: AppFeature[] = [
  {
    emoji: "✍️",
    label: "Seamless travel experience",
    ariaLabel: "writing",
  },
  {
    emoji: "🔔",
    label: "Live updates & exclusive features",
    ariaLabel: "bell",
  },
  {
    emoji: "🤝",
    label: "Make connections",
    ariaLabel: "handshake",
  },
  {
    emoji: "💰",
    label: "Complete quests, earn $ZO",
    ariaLabel: "money",
  },
];

export const APP_STORE_LINKS: AppStoreLinks = {
  ios: "https://apps.apple.com/us/app/zostel/id1620655522",
  android:
    "https://play.google.com/store/apps/details?id=com.zostel.app.android",
};

export const navigationLinks = [
  {
    title: "Zo World",
    links: [
      { to: "/zostel", label: "Zostel" },
      { to: "/zostel-plus", label: "Zostel Plus" },
      { to: "/homes", label: "Zostel Homes" },
      { to: "/zo-trips", label: "Zo Trips" },
    ],
  },
  {
    title: "Zostel",
    links: [
      { to: "/destinations", label: "Destinations" },
      { to: "franchise", label: "Franchises" },
      { to: "/about", label: "About Us" },
      { to: "/contact", label: "Contact Us" },
      { to: "/blog", label: "Blog" },
      { to: "/career", label: "Career" },
      { to: "/merchandise", label: "Merchandise" },
    ],
  },
];

export const socialMediaPlatforms = [
  {
    name: "Instagram",
    link: "https://www.instagram.com/zostel/",
    icon: instagram,
  },
  {
    name: "Youtube",
    link: "https://www.youtube.com/ZostelHostels",
    icon: youtube,
  },
  {
    name: "Linkedin",
    link: "https://in.linkedin.com/company/zostel",
    icon: linkedin,
  },
  {
    name: "Twitter",
    link: "https://twitter.com/zostelhostel",
    icon: X,
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/Zostel/",
    icon: facebook,
  },
];
